'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('prop-types');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var LineItemHeaderMobile = require('./LineItemHeaderMobile.js');
var LineItemRowMobile = require('./LineItemRowMobile.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LineItemsMobile = function LineItemsMobile(props) {
  var lineItems = props.lineItems,
      isMaterialItems = props.isMaterialItems,
      settings = props.settings,
      hasLineItemImages = props.hasLineItemImages;
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 16
  }, React__default["default"].createElement(LineItemHeaderMobile, {
    isMaterialItems: isMaterialItems
  }), lineItems.map(function (value) {
    return React__default["default"].createElement(LineItemRowMobile, {
      lineItem: value,
      settings: settings,
      key: value.id,
      hasLineItemImages: hasLineItemImages
    });
  }));
};

exports.LineItemsMobile = LineItemsMobile;
exports["default"] = LineItemsMobile;
